import React from 'react';
import content from '../../constants/content';
import { useUser } from '../../../../../redux/reducer/user';
import { WISH } from '../../../../../constants/shared/states/names';
import { safeHTML } from '../../../../../utils/safeHTML';
import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import Picture from '../../../../baseComponents/gui/picture/Picture';
import useStateControls from '../../../../../hooks/useStateControls';
import { useRequestsHandlerData } from '../../../../../hooks/useRequestsHandlerData';
import AppLoader from '../../../../features/appLoader/AppLoader';
import { useModal } from '../../../../../hooks/useModal';
import { useApplicationCallbacks } from '../../../../../providers/application-callbacks';
import { isString } from 'lodash';
import { defaultStore, stores, useTranslation } from '../../../../../translations';
import { badWords } from '../../../wish';

const {
  postcard: { bg, text, button, available, modalForId },
} = content;

const Postcard = React.forwardRef(function (_, ref) {
  const { profile: { wishAvailable } = {} } = useUser();
  const { setState } = useStateControls();
  const { addModal, closeModal } = useModal();
  const callbacks = useApplicationCallbacks();
  const { t } = useTranslation();

  const isPending = useRequestsHandlerData([
    {
      address: 'requestsUserGetWishUserData',
      fulfilled() {
        setState(WISH);
        closeModal('all');
      },
    },
  ]);

  const openIdModal = () => {
    addModal({
      type: 'wishModal',
      props: {
        ...modalForId,
        onSubmit({ id } = {}) {
          isString(id) && callbacks.getWishUserData(id);
        },
      },
    });
  };

  return (
    <div className={'friends__postcard'}>
      <div className={'friends__postcard-item'}>
        <p className={'friends__postcard-text'}>{safeHTML(t(text))}</p>
        <div className={'friends__postcard-bg'}>
          <Picture {...bg} />
        </div>
        <CustomButton {...button} disabled={!wishAvailable} onClick={openIdModal} />
      </div>
      <p className={'friends__postcard-available'}>{safeHTML(`${t(available).replace('{count}', wishAvailable)}`)}</p>
      {isPending && <AppLoader />}
    </div>
  );
});
export default Postcard;
Postcard.propTypes = {};
